import { chevronRightCircleFillIcon } from "components/Icon";

export const COVERAGE_INFO_BUTTON = {
  href: "https://rvrentals.zendesk.com/hc/en-us/categories/4418360245271-Insurance-Questions",
  target: "_blank",
  rel: "noopener noreferrer",
  ghost: true,
  label: "Learn more about coverages",
  className: "underline",
  iconPosition: "after",
  icon: chevronRightCircleFillIcon
};
